import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { BusinessContextService } from '../services/business-context.service';
import { NavigationService } from '../services/navigation.service';
import { BusinessCodes, resolveBusinessCapabilityKey } from '../constants/business-codes.constants';

/** Allows the route only while the selected workspace is Agri Supply. */
@Injectable({
  providedIn: 'root'
})
export class AgriSupplyGuard implements CanActivate {
  constructor(
    private businessContext: BusinessContextService,
    private navigationService: NavigationService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const key = resolveBusinessCapabilityKey(
      this.businessContext.selectedBusinessCode,
      this.businessContext.selectedBusinessName
    );

    if (key === BusinessCodes.AgriSupply) {
      return true;
    }

    this.router.navigate([this.navigationService.logoRoute || '/dashboard']);
    return false;
  }
}
